'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _form = require('../form');

var _makerActions = require('../../actions/makerActions');

var _ChartTypeSelector = require('./ChartTypeSelector');

var _ChartTypeSelector2 = _interopRequireDefault(_ChartTypeSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var COLUMN_CHOICES = [{ value: 'value', label: 'Value' }, { value: 'units', label: 'Units' }, { value: 'doors', label: 'Doors' }, { value: 'budget', label: 'Budget' }, { value: 'reorder_value', label: 'Reorder Value' }, { value: 'avg_discount', label: 'Average Discount' }, { value: 'undiscounted_value', label: 'Undiscounted Value' }, { value: 'order_count', label: 'Order Count' }, { value: 'initial_value', label: 'Initial Value' }];

var GROUP_BY_CHOICES = [{ value: 'brand', label: 'Brand' }, { value: 'department', label: 'Department' }, { value: 'territory', label: 'Territory' }, { value: 'store', label: 'Store' }, { value: 'year', label: 'Year' }, { value: 'month', label: 'Month' }, { value: 'season', label: 'Season' }, { value: 'main_season', label: 'Main Season' }, { value: 'order_status', label: 'Order Status' }, { value: 'is_consignment', label: 'Consignment' }, { value: 'is_sor', label: 'SOR' }, { value: 'is_reorder', label: 'Reorder' }, { value: 'market_city', label: 'Market City' }, { value: 'tradeshow', label: 'Tradeshow' }];

var ORDER_BY_CHOICES = {
	dataPoints: [{ value: 'value', label: 'Value' }, { value: 'units', label: 'Units' }, { value: 'doors', label: 'Doors' }, { value: 'budget', label: 'Budget' }, { value: 'reorder_value', label: 'Reorder Value' }, { value: 'avg_discount', label: 'Average Discount' }, { value: 'undiscounted_value', label: 'Undiscounted Value' }, { value: 'order_count', label: 'Order Count' }],
	groupBy: [{ value: 'brand', label: 'Brand' }, { value: 'department', label: 'Department' }, { value: 'territory', label: 'Territory' }, { value: 'store', label: 'Store' }, { value: 'year', label: 'Year' }, { value: 'month', label: 'Month' }, { value: 'season', label: 'Season' }, { value: 'order_status', label: 'Order Status' }, { value: 'market_city', label: 'Market City' }, { value: 'tradeshow', label: 'Tradeshow' }, { value: 'main_season', label: 'Main Season' }]
};

var ChartOptions = function (_React$Component) {
	_inherits(ChartOptions, _React$Component);

	function ChartOptions(props) {
		_classCallCheck(this, ChartOptions);

		var _this = _possibleConstructorReturn(this, (ChartOptions.__proto__ || Object.getPrototypeOf(ChartOptions)).call(this, props));

		_this.orderByChoices = [];

		_this.orderByChoices = _this.getOrderByChoices(props);
		_this.renderChartSpecificOptions = _this.renderChartSpecificOptions.bind(_this);
		return _this;
	}

	_createClass(ChartOptions, [{
		key: 'componentWillUpdate',
		value: function componentWillUpdate(nextProps) {
			this.orderByChoices = this.getOrderByChoices(nextProps);
		}
	}, {
		key: 'getOrderByChoices',
		value: function getOrderByChoices(props) {
			var component = props.component;

			var options = [];

			for (var i = 0; i < ORDER_BY_CHOICES.dataPoints.length; i++) {
				if (component.dataPoints.indexOf(ORDER_BY_CHOICES.dataPoints[i].value) !== -1) {
					options.push(ORDER_BY_CHOICES.dataPoints[i]);
				}
			}

			for (var i = 0; i < ORDER_BY_CHOICES.groupBy.length; i++) {
				if (component.groupBy.indexOf(ORDER_BY_CHOICES.groupBy[i].value) !== -1) {
					options.push(ORDER_BY_CHOICES.groupBy[i]);
				}
			}

			return options;
		}
	}, {
		key: 'render',
		value: function render() {
			var component = this.props.component;


			return _react2.default.createElement(
				'div',
				{ className: 'chart-options' },
				_react2.default.createElement(_form.Input, {
					onChange: this.handleTextChange.bind(this, 'title'),
					placeholder: 'Title',
					value: component.title,
					wrapperClass: 'option-input',
					label: 'Title'
				}),
				_react2.default.createElement(_form.Input, {
					onChange: this.handleTextChange.bind(this, 'description'),
					placeholder: 'Description',
					value: component.description,
					wrapperClass: 'option-input',
					label: 'Description'
				}),
				_react2.default.createElement('hr', null),
				_react2.default.createElement(_ChartTypeSelector2.default, {
					selected: component.chartType,
					onChange: this.handleSelectChangeNoMap.bind(this, 'chartType')
				}),
				_react2.default.createElement('hr', null),
				this.renderChartSpecificOptions()
			);
		}
	}, {
		key: 'renderChartSpecificOptions',
		value: function renderChartSpecificOptions() {
			var component = this.props.component;


			if (!component.chartType) return _react2.default.createElement(
				'div',
				null,
				'Select a chart type to get started.'
			);

			var dataPointsLabel = 'I want to see' + (component.chartType !== 'key-figure' ? '(columns)' : '');

			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(_form.Select, {
					onChange: this.handleSelectChange.bind(this, 'dataPoints'),
					wrapperClass: 'option-input select-dataPoints',
					multi: true,
					options: COLUMN_CHOICES,
					value: component.dataPoints,
					label: dataPointsLabel
				}),
				component.chartType !== 'key-figure' && _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement('hr', null),
					_react2.default.createElement(_form.Select, {
						onChange: this.handleSelectChange.bind(this, 'groupBy'),
						wrapperClass: 'option-input select-groupBy',
						multi: true,
						options: GROUP_BY_CHOICES,
						value: component.groupBy,
						label: 'Group by (rows)'

					})
				),
				_react2.default.createElement('hr', null),
				_react2.default.createElement(_form.Filters, {
					onChange: this.handleSelectChangeNoMap.bind(this, 'filters'),
					label: 'Filters',
					filters: component.filters
				}),
				_react2.default.createElement('hr', null),
				component.chartType !== 'key-figure' && _react2.default.createElement(_form.Select, {
					onChange: this.handleSelectChange.bind(this, 'orderBy'),
					wrapperClass: 'option-input select-orderBy',
					multi: true,
					options: this.orderByChoices,
					value: component.orderBy,
					label: 'Order by'

				})
			);
		}
	}, {
		key: 'handleTextChange',
		value: function handleTextChange(field, e) {
			var _props = this.props,
			    component = _props.component,
			    selectedComponent = _props.selectedComponent,
			    dispatch = _props.dispatch;

			component[field] = e.target.value;
			dispatch((0, _makerActions.updateComponent)(selectedComponent, component));
		}
	}, {
		key: 'handleSelectChange',
		value: function handleSelectChange(field, value) {
			var _props2 = this.props,
			    component = _props2.component,
			    selectedComponent = _props2.selectedComponent,
			    dispatch = _props2.dispatch;

			component[field] = value.map(function (e) {
				return e.value;
			});
			dispatch((0, _makerActions.updateComponent)(selectedComponent, component));
		}
	}, {
		key: 'handleSelectChangeNoMap',
		value: function handleSelectChangeNoMap(field, value) {
			var _props3 = this.props,
			    component = _props3.component,
			    selectedComponent = _props3.selectedComponent,
			    dispatch = _props3.dispatch;

			component[field] = value;
			dispatch((0, _makerActions.updateComponent)(selectedComponent, component));
		}
	}, {
		key: 'handleSelectChangeNoMapSingle',
		value: function handleSelectChangeNoMapSingle(field, value) {
			var _props4 = this.props,
			    component = _props4.component,
			    selectedComponent = _props4.selectedComponent,
			    dispatch = _props4.dispatch;

			component[field] = value.value;
			dispatch((0, _makerActions.updateComponent)(selectedComponent, component));
		}
	}]);

	return ChartOptions;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		report: state
	};
};

ChartOptions = (0, _reactRedux.connect)(mapStateToProps)(ChartOptions);

exports.default = ChartOptions;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/maker/ChartOptions.js
// module id = 572
// module chunks = 0